import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { GetRequestListInfoService } from './api-services/get-request-list-info.service';
import { GetDelivCatalogIdByOrderCodeService } from './api-services/get-deliv-catalog-id-by-order-code.service';
import { GetOrderCodeByDelivCatalogIdService } from './api-services/get-order-code-by-deliv-catalog-id.service';
import { GetOrderCodeMediumListService } from './api-services/get-order-code-medium-list.service';

import { KYMW7007Component } from './kymw7007.component';

/**
 * 表紙・特集商品選定依頼確認（担当バイヤー用）画面 モジュール設定クラス
 *
 * @export KYMW7007Module
 * @class KYMW7007Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW7007Component],
  providers: [
    GetRequestListInfoService,
    GetDelivCatalogIdByOrderCodeService,
    GetOrderCodeByDelivCatalogIdService,
    GetOrderCodeMediumListService,
  ],
})
export class KYMW7007Module {}
